<div
	class="border-darkTertiary bg-darkSecondary hover:border-darkQuaternary group relative h-80 w-full overflow-hidden rounded-lg border p-6 shadow-sm transition-all"
>
	<div class="card-spotlight -top-32 z-0 aspect-square h-80" />
	<div class="grid h-full w-full grid-rows-5 items-center justify-center gap-4">
		<div class="relative row-span-3 flex h-full w-full flex-row items-center justify-center">
			<img
				loading="lazy"
				src="/images/lol/animate/micro-macro/1.svg"
				class="absolute right-28 top-16 h-14 w-14 rounded-full transition-all duration-300 group-hover:h-16 group-hover:w-16"
				alt="micro-macro-1"
			/>
			<img
				loading="lazy"
				src="/images/lol/animate/micro-macro/1.svg"
				class="absolute right-16 top-4 h-14 w-14 rounded-full transition-all duration-1000 group-hover:h-16 group-hover:w-16"
				alt="micro-macro-2"
			/><img
				loading="lazy"
				src="/images/lol/animate/micro-macro/1.svg"
				class="absolute left-16 top-12 h-14 w-14 rounded-full transition-all duration-500 group-hover:h-16 group-hover:w-16"
				alt="micro-macro-3"
			/>
			<img
				loading="lazy"
				src="/images/lol/animate/micro-macro/2.svg"
				class="absolute left-28 top-2 h-10 w-10 rounded-full transition-all duration-700 group-hover:h-14 group-hover:w-14"
				alt="micro-macro-4"
			/>
		</div>
		<div
			class="row-span-2 mx-auto flex h-full w-full max-w-sm flex-col items-center justify-center gap-2 text-center"
		>
			<h3 class="text-xl font-normal">Micro & Macro Tips</h3>
			<p class="text-lightTertiary">
				Summon your inner faker with simple step-by-step walkthroughs of advanced micro & macro
				tips.
			</p>
		</div>
	</div>
</div>
